<span [formGroup]="_form()" class="w-full wrapper">
    @if (showLabel()) {
        <app-float-label>
            @if (icon() || svgIcon()) {
                <p-iconfield [iconPosition]="iconPosition()">
                    @if (iconPosition() === 'left') {
                        <p-inputicon>
                            <app-icon [icon]="icon() || svgIcon()"></app-icon>
                        </p-inputicon>
                        <ng-container *ngTemplateOutlet="inputField"></ng-container>
                    } @else if (iconPosition() === 'right') {
                        <ng-container *ngTemplateOutlet="inputField"></ng-container>
                        <p-inputicon>
                            <app-icon [icon]="icon() || svgIcon()"></app-icon>
                        </p-inputicon>
                    }
                </p-iconfield>
            } @else {
                <ng-container *ngTemplateOutlet="inputField"></ng-container>
            }
            @if (clear() && _form().get(this.id())?.value) {
                <app-icon class="p-inputicon clear" icon="pi-times" (onClick)="clearInput()"></app-icon>
            }
            <label [for]="id()">{{ lbl() | translate }}</label>
        </app-float-label>
    } @else {
        @if (icon() || svgIcon()) {
            <p-iconfield [iconPosition]="iconPosition()">
                @if (iconPosition() === 'left') {
                    <p-inputicon>
                            <app-icon [icon]="icon() || svgIcon()"></app-icon>
                    </p-inputicon>
                    <ng-container *ngTemplateOutlet="inputField"></ng-container>
                } @else if (iconPosition() === 'right') {
                    <ng-container *ngTemplateOutlet="inputField"></ng-container>
                    <p-inputicon>
                        <app-icon [icon]="icon() || svgIcon()"></app-icon>
                    </p-inputicon>
                }
            </p-iconfield>
        } @else {
            <ng-container *ngTemplateOutlet="inputField"></ng-container>
        }
        @if (clear() && _form().get(this.id())?.value) {
            <app-icon class="p-inputicon clear" icon="pi-times" (onClick)="clearInput()"></app-icon>
        }
    }

    <ng-template #inputField>
        @if (uppercaseActive()) {
            <input #inputElement
                uppercase
                [id]="id()"
                [formControlName]="id()"
                [type]="type"
                [attr.placeholder]="placeholder() ?? null"
                [readonly]="readonly()"
                [attr.aria-describedby]="id() + '-help'"
                [autocomplete]="autocomplete() ? 'on' : 'off'"
                [maxlength]="maxLength()"
                pInputText
                class="w-full"
                [class.p-filled]="filled()"
                [ngClass]="{ 'p-disabled': disabled(), 'required-input-border': required() }"
            />
        } @else {
            <input #inputElement
                [id]="id()"
                [formControlName]="id()"
                [type]="type"
                [attr.placeholder]="placeholder() ?? null"
                [readonly]="readonly()"
                [attr.aria-describedby]="id() + '-help'"
                [autocomplete]="autocomplete() ? 'on' : 'off'"
                [maxlength]="maxLength()"
                pInputText
                class="w-full"
                [class.p-filled]="filled()"
                [ngClass]="{ 'p-disabled': disabled(), 'required-input-border': required() }"
            />
        }
    </ng-template>
</span>
@if (showHelpText()) {
    <small [id]="id() + '-help'">{{ helpTxt() | translate }}</small>
}
<app-field-error [form]="_form()" [id]="id()"></app-field-error>
